export enum EIconType {
    EYE = "eye",
    ENVELOPE = "envelope",
    DOWNLOAD = "download",
    PASSPORT = "passport",
    ELECTRICITY = "electricity",
    OTHER = "other",
}
